//copyright Filipe Montebeller Rocha
//copyright Filipe Montebeller Rocha
//copyright Filipe Montebeller Rocha
//copyright Filipe Montebeller Rocha

//component utilizado para selecionar a cor da rota no cadastro

import React, { useEffect, useState } from "react";

const ColorPicker = ({ valor, setValor, colorsPerRow = 7 }) => {

	const colors = [
		"#fff185",
		"#fed86c",
		"#fdbf53",
		"#fba639",
		"#fa8d20",
		"#fa0611",
		"#f50612",
		"#e11e3a",
		"#cb142c",
		"#b50a1d",
		"#9f000f",
		"#a00000",
		"#a01a00",
		"#a03600",
		"#a05000",
		"#a06a00",
		"#a08600",
		"#a0a000",
		"#86a000",
		"#6aa000",
		"#50a000",
		"#36a000",
		"#1aa000",
		"#00a000",
		"#00a01a",
		"#00a036",
		"#00a050",
		"#009b57",
		"#00ae68",
		"#008846",
		"#00a06a",
		"#00a086",
		"#00a0a0",
		"#0086a0",
		"#006aa0",
		"#0050a0",
		"#0036a0",
		"#0f1dc8",
		"#001aa0",
		"#0000a0",
		"#00007e",
		"#001b78",
		"#53005a",
		"#79077d",
		"#900094",
		"#a405a7",
		"#b90aba",
		"#cd0fcc",
		"#e114df"
		
	];

	let linhas = [];
	const [rows, setrows] = useState([]);

	useEffect(() => {
		// eslint-disable-next-line react-hooks/exhaustive-deps
		linhas = [];
		for (let i = 0; i < colors.length; i++) {
			if (i % colorsPerRow === 0) {
				linhas.push([]);
			}

			linhas[Math.floor(i / colorsPerRow)].push(colors[i]);
		}
		setrows(linhas);
	}, []);

	return (
		<div
			style={{
				transition: "all 0.2s ease-in-out",
				position: "absolute",
				top: 20,
				right: "100%",
				padding: 1,
				borderRadius: 15,
				width: "fit-content",
				height: "fit-content",
				backgroundColor: "white",
				border: "1px solid var(--color-text)",
			}}
		>
			{/* <input type="color" value={valor} onChange={e => setValor(e.target.value)}/> */}
			{rows.map((r, i) => {
				return (
					<div
						style={{
							width: "100%",
							display: "flex",
							flexDirection: "row",
							alignSelf: "stretch",
							justifyContent: "flex-end",
							alignItems: "center",
						}}
						key={i}
					>
						{r.map((c, i) => {
							return (
								<div
									onClick={() => {
										setValor(c);
									}}
									style={{
										width: 25,
										aspectRatio: 1,
										margin: 5,
										padding: 2,
										cursor: "pointer",
										backgroundColor: c,
										borderWidth: 2,
										borderColor: c === valor ? "#333333" : "transparent",
										borderRadius: 1000,
									}}
									key={i}
								>
									<div style={{}}></div>
								</div>
							);
						})}
					</div>
				);
			})}
		</div>
	);
};

export default ColorPicker;

//copyright Filipe Montebeller Rocha
